export default __webpack_public_path__ + "static/media/sign-out-alt.6b3077a0.svg";